// Combo Box Default
export const NONE_SELECTED = "none selected";

// Shipping Method Selections
export const EXPEDITED = "expedited";
export const STANDARD = "standard";

// Content Types
export const KNOW_BEFORE_YOU_GO = "know-before-you-go";

// Pass Types
export const ANNUAL = "ANNUAL";
export const MILITARY = "MILITARY";
export const ACCESS = "ACCESS";
export const SENIOR = "SENIOR";

// Pass Images
// const PASS_IMG_PREFIX = `${process.env.CDN}/img/pass/`;
export const PASS_IMG_PREFIX = `${process.env.CDN}/img/pass/`;
export const ANNUAL_PASS_IMAGE = `${PASS_IMG_PREFIX}annual_pass.png`;
export const FOURTH_GRADE_PASS_IMAGE = `${PASS_IMG_PREFIX}fourth_grade_pass.png`;
export const SENIOR_LIFETIME_PASS_IMAGE = `${PASS_IMG_PREFIX}senior_lifetime_pass.png`;
export const SENIOR_ANNUAL_PASS_IMAGE = `${PASS_IMG_PREFIX}senior_annual_pass.png`;
export const VOLUNTEER_PASS_IMAGE = `${PASS_IMG_PREFIX}volunteer_pass.png`;
export const MILITARY_PASS_IMAGE = `${PASS_IMG_PREFIX}military_pass.png`;
export const ACCESS_PASS_IMAGE = `${PASS_IMG_PREFIX}access_pass.png`;

// Pass Type IDs
export const ANNUAL_PASS_ID = '7005cd6e-8386-458e-b4b1-8b382bf70889';
export const MILITARY_PASS_ID = "7505cd6e-8386-458e-b4b1-8b382bf70889";
export const ACCESS_PASS_ID = "7305cd6e-8386-458e-b4b1-8b382bf70889";
export const SENIOR_PASS_ID = "7205cd6e-8386-458e-b4b1-8b382bf70889";

export const ROUTE_PREFIX = '/pass/';
export const PASS_PREFIX = 'PASS_';

// Park Pass Release Flag
export const PARK_PASS_IS_COMING = process.env.NODE_ENV !== 'development';
